import React, { PropTypes, Component } from "react";
import { inject, observer } from "mobx-react";
import {Button, Col, Form, FormGroup, FormText, Input, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, InputGroup, InputGroupAddon} from 'reactstrap';
import {createSelectOptions, inteiroPositivo} from "../../../utils/formatar";
import {Validacao} from "../../comum/components/Validacao";
import DataWrapper from "../../principal/containers/DataWrapper";
import SolicitacaoRetroativaStore from "../stores/SolicitacaoRetroativaStore";
import {MensagemErro} from "../../comum/components/MensagemErro";
import Select from "react-select";
import {
    statusSolicitacaoConcluidaEnum,
    tipoSolicitacaoRetroativa,
    tipoSolicitacaoRetroativaEnum
} from "../../../utils/enums";
import {Redirect} from "react-router-dom";

@inject("store")
@DataWrapper
@observer
export class SolicitacaoRetroativa extends Component {
    constructor(props) {
        super(props);
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.modalStore = this.props.store.modalStore;
        this.controller = new SolicitacaoRetroativaStore(this.modalStore, this.validacaoStore);
    }

    componentWillMount() {
        this.controller.solicitacaoEttId = null;
        this.controller.erro = null;
        this.controller.urlObtida = null;
        this.tipo = null;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Solicitação retroativa");
    }

    render() {
        if (this.controller.urlObtida) {
            return <Redirect to={this.controller.urlObtida}/>;
        } else {
            return this.renderForm();
        }
    }

    renderForm() {
        const tipoOptions = createSelectOptions(tipoSolicitacaoRetroativaEnum, "id", "valor");
        return (
            <div>
                <div className="form-wrapper">
                    <div className="content-panel panel-sm">
                        <Form className="panel-form">
                            <div>
                                <MensagemErro>
                                    {this.controller.erro}
                                </MensagemErro>
                                <Row>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <Label>Tipo <sup>*</sup></Label>
                                            <Select value={this.controller.tipo}
                                                    options={tipoOptions}
                                                    onChange={(value) => this.controller.setTipo(value)}
                                                    noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                                    multi={false} />
                                            <Validacao id="tipo" valor={this.controller.tipo} tipo={["isRequired"]} />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <Label>Número solicitação ETT <sup>*</sup></Label>
                                            <Input type="text" value={this.controller.solicitacaoEttId} onChange={(event) => this.controller.setSolicitacaoEttId(event.target.value)} maxLength={18} />
                                            <Validacao id="solicitacaoEttId" valor={this.controller.solicitacaoEttId} tipo={["isRequired"]} />
                                        </FormGroup>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <Button color="primary" onClick={() => this.controller.obterUrl()} >Confirmar</Button>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
}